import { render } from "./WithdrawalRecord.vue?vue&type=template&id=36aa4134&scoped=true"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js"

import "./WithdrawalRecord.vue?vue&type=style&index=0&id=36aa4134&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36aa4134"]])

export default __exports__